export default __webpack_public_path__ + "static/media/account-ico-phone.a2297fff.svg";